import React from 'react';
import {
	SpanStyle,
	BagdeStyle,
	CardBody,
	Card,
} from './panel.style';

const Panel = ({
	title, subTitle, titleName, contador, body, qtdCaracteres, idap, style, styleBody,
}) => (
	<Card className='card mb-2' style={style}>
		<div className='card-header'>
			<SpanStyle title={titleName}>
				{title}
				{contador ? (
					<BagdeStyle className='badge badge-pill badge-light ml-1'> {contador} </BagdeStyle>

				) : (
					<span>{' '}</span>
				)}
			</SpanStyle>
		</div>
		<CardBody style={styleBody}>
			{subTitle ? (
				<p className='ml-2'>{subTitle}</p>
			) : (
				' ')}
			{body}
			{qtdCaracteres ? (
				<p className='text-right'>
					{qtdCaracteres}
					{' '}
					<span>caracteres restantes</span>
				</p>
			) : (
				' ')}
			{idap}

		</CardBody>
	</Card>

);
export default Panel;
